import React, { useState } from 'react';
import {
  Typography,
  Select,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  TextField,
  FormControl,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GenericTooltip from '../../../../../platform/components/common/genericToolTip';

const BufferTimeSettings = ({
  tooltipData,
  increments,
  setIncrements,
  isDisabled,
}) => {

  const [timeUnit, setTimeUnit] = useState('mins'); // Default unit

  // Adjusted value displayed to the user based on selected unit
  const displayedValue = timeUnit === 'hours' ? increments / 60 : increments;

  const handleTimeValueChange = (e) => {
    const value = Math.max(0, Number(e.target.value)); // Ensure non-negative
    setIncrements(timeUnit === 'hours' ? value * 60 : value); // Always store in minutes
  };

  const handleUnitChange = (e) => {
    setTimeUnit(e.target.value); // Change only the displayed unit
  };

  return (
    <Accordion defaultExpanded sx={{ boxShadow: 'none', border: 'none' }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>
          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <h4 style={{ margin: 0 }}>Buffer time</h4>
            <GenericTooltip title={tooltipData?.bufferTime} />
          </div>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            maxWidth: "400px",
            gap: "20px",
          }}
        >
          <Typography>Add time between appointments</Typography>
          <div style={{ width: "100%" }}>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={3} sm={3}>
                <TextField
                  type="number"
                  value={displayedValue} // Display adjusted value
                  onChange={handleTimeValueChange} // Convert and store as minutes
                  disabled={isDisabled}
                  fullWidth
                  inputProps={{ min: 0 }}
                  sx={{
                    textAlign: "right",
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                      borderBottom: '2px solid lightgray',
                    }
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={4}>
                <FormControl fullWidth disabled={isDisabled}>
                  <Select
                    value={timeUnit}
                    onChange={handleUnitChange}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        border: 'none',
                        borderBottom: '2px solid lightgray',
                      },
                    }}
                  >
                    <MenuItem value="mins">Minutes</MenuItem>
                    <MenuItem value="hours">Hours</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default BufferTimeSettings;
